import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: Number }

  connect() {
    const timeout = this.timeoutValue || 4000
    setTimeout(() => {
      this.element.style.opacity = "0"
      this.element.style.transition = "opacity 0.3s"
      setTimeout(() => this.element.remove(), 300)
    }, timeout)
  }
}
